export const urlToServer = "https://51.20.5.42";
// https://51.20.5.42 - Amazon EC2 server (not working with local app, only gh-pages)
// http://localhost:4000 - local
